export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10095.2865eb79.jpg";